export default function () {
  this.loadReviews()
}
